import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AppComponent } from '../app.component';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { ThumbnailService } from '../thumbnail.service';

@Component({
  selector: 'app-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['./new-order.component.scss'],
})
export class NewOrderComponent  {
  loader:boolean = true;
  showQty;
  showDiv:boolean=false;
  showAdd:boolean=true;
  cartView:boolean=false;
  cartload: boolean = false;
  initialTypePopup:boolean = false;
  storeObj:any=[];
  users;
  contactNbrMob;
  filterData:any=[];
  itemTypeId;
  category;
  cateCode;
  search;
  msg;
  name;
  purrchaseItems;
  delRegion;
  id;
  conveyanceChrg;
  url;
Ind;
region;
orderId;
preOrderId;
orderItems: any =[];
itemtypeObj:any=[];
typeName;
typeId;
notes;
detailText;
detailsPop:boolean=false;
amtLoader:boolean;
squareFeet:boolean=false;
orderEditQty:any=[]
otherItem;
slideOpts={
  loop:false,
  effect: 'slide',
  slidesPerView: 4,
  spaceBetween: 8
}
showSearch:boolean;
carType:any=[];
docId;
pic;
typePopupCheck:boolean;
credits:boolean;
makeName;
makeId;
modelName;
makeObj;
popLoad:boolean;
modelObj;
modelId;
typeObj;
userId;
typeCode;
updatePop:boolean=false;
fDate;
startdate;
slotDate;
time = "Time";
openSlot:boolean = false;
creditCheck: boolean = true;
couponCheck:boolean =true;
slotClicked:boolean;
availableSlots:any=[];
availSlot:boolean;
fdateCheck;
orgId=localStorage.getItem('organizationId')
endTime;
slot;
data;
criditValue;
config;
changeDate:boolean = false;
dateFormat;
discountAmt;
couponcode:boolean;
mixedbooking:boolean;
mixedvalue;
typeConfirmPop:boolean;
mixcheck:boolean;
mixvalue;
itemname;
block:boolean;
extrasCheck:boolean;
  travelCharges: any;
  visitingCharge: any;
  costVar:boolean=false;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    private bottomSheet: MatBottomSheet, 
    public thumb:ThumbnailService,
    public auth: AuthService,
    public location: LocationService, 
    public app: AppComponent,
    protected sanitizer: DomSanitizer,
      public platform: Platform) { }

  ionViewWillEnter(){
    sessionStorage.removeItem('newOrderId')
    this.typeName = "ALL"
    this.url=window.location.href;
    this.cartView=false;
    this.orderItems.orderAmountStr="";
    this.id=this.url.split('/').pop();
    this.preOrderId=sessionStorage.getItem('orderId')
    if(this.url.includes('home-new-order') ||this.url.includes('createNewOrder') ||this.url.includes('homeNewOrder') ){
      this.block=true;
    }else{
      this.block=false;
    }
    if(this.url.includes('createNewOrder') ||this.url.includes('homeNewOrder')){
      this.extrasCheck = true;     
      this.userId = sessionStorage.getItem('userId')
      this.getUsers();
    }else{
      this.getById();
      this.extrasCheck = false;
    }
 this.getConfig()
    this.blockDate() 
    this.dateFormat = this.auth.getDateformat();
    // this.getAllService();   
  }
  async getConfig(){
    this.data= await this.service.getConfig().toPromise();
    if(this.data){
       let x= this.data.find(res=>res.name=="Billing Config");
      this.config = x.configs.find(dat=>dat.shortCdConst=="ACP");
       this.criditValue=this.config.userValue;

    }
  }

  
  getUsers(){  
    this.service.getUserById(this.userId).subscribe((res:any) => {
      // this.loader=false;
      this.users = res;  
      this.handler.custName = this.users.firstName;
      this.handler.contactNbrMob = this.users.contactNbrMob;
      if(this.users.addresses[0]){
      this.handler.regionId=this.users.addresses[0].regionId;
      this.handler.street=this.users.addresses[0].street;
      this.handler.stateId=this.users.addresses[0].stateId;
      this.handler.cityId=this.users.addresses[0].cityId;
      this.handler.zipcode=this.users.addresses[0].zipcode; 
      this.handler.appt=this.users.addresses[0].appt;
      if(!this.handler.appt){
        this.handler.flatType = 1;
      }else{
        this.handler.flatType = 2;
      }
      this.handler.doorNbr=this.users.addresses[0].doorNbr;
      this.handler.flatName=this.users.addresses[0].flatName;
      this.handler.flatNo=this.users.addresses[0].flatNo;
      }
      
       },err=>{
        this.handler.err(err)
        this.loader = false;
      }) 
      this.getCategory();
  }

  
// getitemTypeInCreate(){
//   this.service.getItemTypeByCategory(this.id).subscribe((res: any)=>{
//     if(res){
//       var x= {id:0,name:"All"}
//       this.itemtypeObj.push(x)
//       res.map(dat=>{
//         this.itemtypeObj.push(dat)
//       })
//     }
//   })
// }
getitemTypeInCreate(){
  this.service.getItemTypeByCategory(this.id).subscribe((res: any)=>{
    if(res){
      this.itemtypeObj= res;
      // this.itemtypeObj.map(res=>{
      //   if(res.id==this.itemTypeId){
      //     Object.assign(res,{highlight:true})
      //   }  
      // })   
      this.itemtypeObj.map(dat1=>{
        Object.assign(dat1,{highlight:false})
      }) 
      this.itemtypeObj.map(dat2=>{
        if(dat2.docId){
          this.thumb.getThumbIcon1(dat2);
        }
      }) 
          if(this.url.includes('vendor-new-order')||this.url.includes('home-new-order')||this.url.includes('admin-new-order')|| this.url.includes('createNewOrder') || this.url.includes('contracter-new-order') || this.url.includes('homeNewOrder') ){
          this.otherItem = this.itemtypeObj[0];
          Object.assign(this.otherItem,{highlight:true})
          this.routeToItems(this.otherItem) 
          }
       
      // this.loader=false;   
       }else{
        //  this.loader=false;
       }
  }, err=>{
    this.loader=false;
    this.handler.err(err)  
  })
}

openBottomSheet(){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.itemtypeObj,
  });

  dialogRef.afterDismissed().subscribe((res:any) => {
    if (res) {
      this.loader = true;
      this.typeName = res.name;
      this.typeId = res.id;
      if(res.id == 0){
        this.getAllService();
      }else{
        this.routeToItems(res);
      }
    }
  });
}

routeToItems(item){
  // this.editFlow = false;
  this.itemtypeObj.map(res=>{
    if(res.id == item.id){
      res.highlight = true;
    }else{
      res.highlight = false;
    }
  })
  // this.otherItemPop=false;
  this.itemTypeId=item.id;
  sessionStorage.setItem('itemTypeId',this.itemTypeId);
  sessionStorage.setItem('itemTypeEdit',this.itemTypeId);
  sessionStorage.setItem('itemCatEdit',item.itemCategory);
  // this.storeObj = this.filterData.filter(res=>{ return res.subCost[0].itemTypeId==item.id}) ;
  this.itemtypeObj.sort(function(a, b) {
    return b.highlight - a.highlight 
  })
  this.getService();
 }

 getAllService(){ 
  this.Ind=false; 
  this.service.getAllItemsByCategory(this.id,this.Ind).subscribe((res:any)=>{
   this.storeObj = res;
   this.filterData = res;
   this.storeObj.map(res1=>{
    Object.assign(res1, { select: false, qty: 0, showQty: 0,success:false,amtLoader:true}) 
   }) 
  this.storeObj = this.storeObj.filter(res=>{return res.packageInd == false})
    if(this.itemTypeId && this.cateCode=='CAR'){   
    this.storeObj.map(dat=>{
      // this.getCost(dat);
     })
  }else {
      this.storeObj.map(dat1=>{
        dat1.subCost.map(dat2=>{
        if(dat2.itemTypeId==this.itemTypeId){
          dat1.success = true;
        }
        })
      })    
      // this.storeObj.map(dat=>{       
      //   this.getCost(dat);
      //  })
     this.storeObj.map(dat3=>{
      if(dat3.imageId){   
        this.thumb.getThumbIcon(dat3)
      }
     })
  
     this.loader = false;  
  } 
  this.storeObj.map(dat3=>{
    if(dat3.imageId){   
      this.thumb.getThumbIcon(dat3)
    }
  })
 
   this.loader = false; 
 },err =>{
   this.handler.err(err)
   this.loader = false;    
 })  
   
}



  getById(){
    this.loader=true;
    if(sessionStorage.getItem('newOrderId')){
      this.preOrderId=sessionStorage.getItem('newOrderId')
    }
    this.service.getOrderById(this.preOrderId).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.purrchaseItems = res; 
        this.delRegion = res.delRegion;
          this.userId = res.customer?.userId;
          this.orderEditQty = res.itemOrders;
          if(res.couponCode){
          this.couponcode = true;
        }else{
          this.couponcode = false;
        }  
        if(res.creditPoints){
          this.credits=true;
        } else{
          this.credits=false;
        }  
        if(this.cateCode=="CAR"){
          this.itemTypeId = this.orderEditQty[0].itemTypeId;
          sessionStorage.setItem('itemTypeId',this.itemTypeId)
          this.service.getItemTypeByCategory(this.id).subscribe(res=>{
            this.carType = res;
            this.carType.map(dat=>{
              if(dat.id == this.itemTypeId){
                this.typeName=dat.name
                this.docId=dat.docId
                this.getDoc(this.docId)
              }
            })
          })
        }
        this.getUsers();
        this.loader=false;
        // this.itemTypeId = sessionStorage.getItem('itemTypeId')      
      }
    },
      err => {
        this.handler.err(err.error)
      })
     
      this.getCategory();
  }
  getDoc(data){
    this.service.getAdImage(data).subscribe(res => {
      this.pic = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
    })
  }

  cancel(){
    if(this.url.includes('vendor-new-order') && (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))){
      this.router.navigate(['/vendor-request'])
    }else if(this.url.includes('createNewOrder')){
     this.router.navigate(['/admin-manage-order'])
    }else if(this.url.includes('homeNewOrder')){
      this.router.navigate(['/vendor-manage-order'])
     }else if((this.url.includes('vendor-new-order') || this.url.includes('createNewOrder')) && (this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')) ){
      this.router.navigate(['/admin-manage-order'])
    }else if(this.url.includes('home-new-order')  && (this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')) ){
      this.router.navigate(['/vendor-manage-order'])
    }
    else{
      this.router.navigate(['/requests'])
    }
    
  }

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      if(res){
        this.category = res;
        this.category.map(dat=>{
          if(this.id==dat.id){
            this.cateCode=dat.code;
            this.mixedvalue=dat.mixedBooking;
          }
        })

         if(this.mixedvalue==true){
           this.mixedbooking=true;
         }else{
           this.mixedbooking=false;
         }
        if(this.cateCode =="PSC" || this.cateCode =="S&F" || this.cateCode =="PT" ){              
          this.squareFeet=true;  
          }else{
            this.squareFeet=false;
          }
          if(this.cateCode!="CAR"){  
         this.getitemTypeInCreate(); 
          }else{
            this.initialTypePopup=true;
          this.getCustMake();
          this.showSearch=true;
          } 
      }
    })

  }

 
  getService(){ 
    this.Ind=false; 
    this.initialTypePopup=false;
    this.loader=true
    this.service.getAllItemsByCategory(this.id,this.Ind).subscribe((res:any)=>{
     this.storeObj = res;
     this.filterData = res;
     this.storeObj.map(res1=>{
      Object.assign(res1, { select: false, qty: 0, showQty: 0,success:false,amtLoader:true,mixedbook:this.mixedbooking}) 
     })
     console.log(this.mixedbooking)
    this.storeObj = this.storeObj.filter(res=>{return res.packageInd == false && res.itemCategoryId==this.id})
      if(this.itemTypeId && this.cateCode=='CAR' && (this.url.includes('home-new-order') ||this.url.includes('createNewOrder') ||this.url.includes('homeNewOrder') || this.url.includes('vendor-new-order') )){   
        this.costVar=true;
      this.storeObj.map(dat=>{
        this.getCost(dat);
       })
    }else {
      this.costVar=false;
        this.storeObj.map(dat1=>{
          if(dat1.subCost){
          dat1.subCost.map(dat2=>{
          if(dat2.itemTypeId==this.itemTypeId){
            dat1.success = true;
          }
          })
        }
        })
        if(this.orderId){
          this.getOrder(this.orderId);
        }   
        this.storeObj = this.storeObj.filter(dat1=>{return dat1.success})
        if(this.url.includes('home-new-order') ||this.url.includes('createNewOrder') ||this.url.includes('homeNewOrder') || this.url.includes('vendor-new-order')){  
       this.costVar=true;
        this.storeObj.map(dat=>{       
          this.getCost(dat);
         })
        }else{
          this.costVar=false;
        }
       this.storeObj.map(dat3=>{
        if(dat3.imageId){   
          this.thumb.getThumbIcon(dat3)
        }
       })
    
       this.loader = false;  
    } 
    this.storeObj.map(dat3=>{
      if(dat3.imageId){   
        this.thumb.getThumbIcon(dat3)
      }
    })
   
     this.loader = false; 
   },err =>{
     this.handler.err(err)
     this.loader = false;    
   })  
     
  }

  getCost(data){
    var data1={
      "itemTypeId": this.itemTypeId,
      "region": this.handler.regionId,
      "serviceId":data.id
    }
    this.service.getCost(data1).subscribe((res:any)=>{
      if(res!=null){
        data.cost= res[0].cost;         
      }else{
        data.cost = data.dfltCost;
        Object.assign(data,{show:true})        
      } 
      data.amtLoader=false;       
    }, err => {    
      this.handler.err(err);
    }) 
  }

  addQuantity(data) {
    this.showDiv=false;  
    this.storeObj.map(res => {
        if (res != data)
          res.select = false;
        else
          res.select = true
      })      
        data.showQty = data.showQty + 1;
        if(data.showQty > 0){
          this.cartView = true;
        }
      if(!this.orderId){       
        this.createOrder(); 
      } else{
        if(this.mixvalue == data.subCost[0].itemTypeId || (data.mixedbook==true && this.mixvalue != data.subCost[0].itemTypeId)){
          this.updateOrder();
        }else{
          data.showQty=0
          this.showDiv=true;
          this.typeConfirmPop=true;
        }     
      }  
    
     

}

  decQuantity(data) {
    this.showDiv=false;  
    this.storeObj.map(res => {
      if (res != data)
        res.select = false;
      else
        res.select = true
    })
       if (data.showQty == 0)
        data.showQty = data.showQty;
      else {
        data.showQty = data.showQty - 1;
        this.updateOrderItem()
      } 
  }
  createOrder() {
    this.cartload = true;
    this.showAdd = false;
    let item = this.storeObj.find(res => res.showQty != 0 && res.select);
  
    item.qty = 1;
    if(this.url.includes('createNewOrder') || this.url.includes('homeNewOrder')){
      let postData = { 
        "customerId":this.users.userId,
        "orgId":localStorage.getItem('organizationId'),  
        "categoryId":this.id,
        "cnvcChargeApplied":true, 
        "delDoorNbr": this.handler.doorNbr,
        "delStreet": this.handler.street,
        "delCity": this.handler.cityId,
        "delState":this.handler.stateId,
        "region":this.handler.regionId,
        "delRegion":this.handler.regionId,
        "lat":this.handler.lat,
        "lon":this.handler.lon,
        "appt":this.handler.appt,
        "custName"  :this.handler.custName,
        "custContactNbrMob":this.handler.contactNbrMob,
        "status": 1,
        "paymtStatus": 1,
        "vendorPaymentStatus":1,
        "paymtMode": 1,
        "orderType" : 1,
        "orderItems" :[
            {
                "id" : item.id,
                "qty": item.qty,
                "billPostVisit":item.billPostVisit
            }
        ],
        "providerServiceId" : item.id      
      }
      if(!this.handler.appt){
        Object.assign(this.orderItems,{"delDoorNbr":this.handler.doorNbr,"delStreet": this.handler.street})
      }else{
        Object.assign(this.orderItems,{"flatNo":this.handler.flatNo, "flatName":this.handler.flatName,})
      }
      if(this.cateCode=="CAR"){
        Object.assign(postData,{"itemTypeId":sessionStorage.getItem('itemTypeId')})
      }else{
        Object.assign(postData,{"itemTypeId":this.itemTypeId})
      }
      this.service.placeOrder(postData).subscribe((res: any) => {
        if(res){
          console.log(res)
          this.orderId = res.id;
          sessionStorage.setItem('newOrderId',this.orderId)
          this.cartload = false;
          this.mixvalue =res.itemTypeId;
          console.log(this.mixvalue)
          this.itemtypeObj.map(dat2=>{
            if(dat2.id==this.mixvalue){
              this.itemname=dat2.name;
            }
          })
          this.orderItems = res;        
        this.getOrder(this.orderId);
          this.showDiv=true;
          this.showAdd=true;
        }
     
      },
        err => {
          this.handler.err(err);
              this.cartload = false;  
        })
    }else{
    let postData = { 
      "customerId":this.purrchaseItems.customerId,
      "orgId":this.purrchaseItems.orgId,
      "cnvcChargeApplied":true,  
      "categoryId":this.id, 
      "delDoorNbr": this.purrchaseItems.delDoorNbr,
      "delStreet": this.purrchaseItems.delStreet,
      "delCity": this.purrchaseItems.delCity,
      "delState":this.purrchaseItems.delState,
      "region":this.purrchaseItems.delRegion,
      "delRegion":this.purrchaseItems.delRegion,
      "lat":this.purrchaseItems.lat,
      "lon":this.purrchaseItems.lon,
      "vendorId":this.purrchaseItems.vendorId,
      "serviceContractorId":this.purrchaseItems.serviceContractorId,
      "appt":this.purrchaseItems.appt,
      "custName"  :this.purrchaseItems.custName,
      "custContactNbrMob":this.purrchaseItems.custContactNbrMob,
      "status": 10,
      "oldOrderId":sessionStorage.getItem('orderId'),
      "paymtStatus": 1,
      "vendorPaymentStatus":1,
      "paymtMode": 1,
      "orderType" : 1,
      "orderItems" :[
          {
              "id" : item.id,
              "qty": item.qty,
              "billPostVisit":item.billPostVisit
          }
      ],
      "providerServiceId" : item.id      
    }
    if(!this.purrchaseItems.appt){
      Object.assign(this.orderItems,{"delDoorNbr":this.purrchaseItems.delDoorNbr,"delStreet": this.purrchaseItems.street})
    }else{
      Object.assign(this.orderItems,{"flatNo":this.purrchaseItems.flatNo, "flatName":this.purrchaseItems.flatName,})
    }
    if(this.cateCode=="CAR"){
      Object.assign(postData,{"itemTypeId":sessionStorage.getItem('itemTypeId')})
    }else{
      Object.assign(postData,{"itemTypeId":this.itemTypeId})
    }
    this.service.placeOrder(postData).subscribe((res: any) => {
      if(res){
        this.orderId = res.id;
        sessionStorage.setItem('newOrderId',this.orderId)
        this.cartload = false;
        this.orderItems = res;        
        this.mixvalue =res.itemTypeId;
        this.itemtypeObj.map(dat2=>{
          if(dat2.id==this.mixvalue){
            this.itemname=dat2.name;
          }
        })
        this.getOrder(this.orderId);
        this.showDiv=true;
        this.showAdd=true;
      }
   
    },
      err => {
        this.handler.err(err);
            this.cartload = false;  
      })
    }
  }
 

  getOrder(id) {
    this.service.getOrderByIdOri(id).subscribe((res: any) => {
      this.cartload = false;
      this.orderItems = res; 
      this.travelCharges= res.travelChargeStr;
      this.visitingCharge=res.visitChargeAdjustmentStr;
      this.conveyanceChrg = res.convenienceChargeStr;
      this.orderEditQty=res.itemOrders; 
      if(res.couponCode){
        this.couponcode = true;
      }else{
        this.couponcode = false;
      }  
      if(res.creditPoints){
        this.credits=true;
      } else{
        this.credits=false;
      }  
      if (this.orderItems.itemOrders) {
        this.storeObj.map(dat => {
          this.orderItems.itemOrders.map(dat1 => {
            if (dat.id == dat1.itemId)
              dat.showQty = dat1.qty;
          })
        })
      }
    }, err => {
      this.cartload = false;
      this.handler.err(err)
       })
  }
  updateOrder() {  
    this.showAdd=false;
    let item;
    item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);      
      item.qty = 1;
    let products = {      
      "orderItems" :[
        {
            "id" : item.id,
            "qty" :item.qty,
            "billPostVisit":item.billPostVisit
        }
    ],
    providerServiceId:item.id,
     
      orderType : 1,
      itemTypeId:this.itemTypeId }
      if(this.url.includes('createNewOrder') || this.url.includes('homeNewOrder')){
        Object.assign(products,{ region:this.handler.regionId})
      }else{
        Object.assign(products,{ region:this.purrchaseItems.delRegion})
      }
      Object.assign(products,{ cnvcChargeApplied:true})
    this.cartload = true; 
    this.service.orderItemPost(this.orderId, item.id, products).subscribe((res:any) => {
      if(res){
        this.getOrder(this.orderId);
        this.cartload = false;
        this.orderItems = res;        
       this.showDiv=true;
        this.showAdd=true;
      }

    },
      err => {
        this.cartload = false;
              this.handler.err(err)
      })
  }

  async updateOrderItem(){
    let item;
    item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);
    // item.qty = item.showQty;
    item.qty = 1;
    let products = {      
      "orderItems" :[
        {
            "id" : item.id,
            "qty" :item.qty,
            "billPostVisit":item.billPostVisit
        }
    ],
    providerServiceId:item.id,
      orderType : 1,
      itemTypeId:this.itemTypeId }
      if(this.url.includes('createNewOrder') || this.url.includes('homeNewOrder')){
        Object.assign(products,{ region:this.handler.regionId})
      }else{
        Object.assign(products,{ region:this.purrchaseItems.delRegion})
      }
      Object.assign(products,{ cnvcChargeApplied:true})  
      this.cartload=true;
          this.service.updateOrderItem(this.orderId, item.id, products).subscribe(res => {
        if(res){
          this.cartload = false;
          this.showDiv=true;
          this.showAdd=true;
          this.orderItems = res;          
         }
        this.getOrder(this.orderId);
       
      },
        err => {
          this.cartload = false;
               this.handler.err(err)
        })
          }

    PlaceOrder(){ 
       this.loader=true;  
          var post={
            orderType:1
          }
          if(this.url.includes('createNewOrder') || this.url.includes('homeNewOrder')){
            Object.assign(post,{status:7})
          }else{
            Object.assign(post,{status:10})
          }
          this.service.completeOrder(sessionStorage.getItem('newOrderId'),post).subscribe(res => {
            this.handler.res("Services Added SuccessFully");    
            if(this.url.includes('vendor-new-order') && (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))){
              this.router.navigate(['/vendor-request'])
            }else if(this.url.includes('createNewOrder') && (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))){
             this.router.navigate(['manage-Order'])
            }else if((this.url.includes('vendor-new-order') || this.url.includes('createNewOrder')) && (this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')) ){
              this.router.navigate(['/admin-manage-order'])
            }else if(this.url.includes('home-new-order')  && (this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')) ){
              this.router.navigate(['/vendor-manage-order'])
            }
            else if(this.url.includes('homeNewOrder')&&(this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))){
              this.router.navigate(['/vendor-manage-order'])
            }
            else{
              this.router.navigate(['/requests'])
            }
            this.loader=false; 
          },
            err => {  
              this.loader=false; 
              this.handler.err(err);     
            })
           }
  
           typeUpdate(){
            this.typePopupCheck=true;
            this.makeName="";
            this.makeId="";
            this.getCustMake();
          }
          getCustMake(){
            this.modelName = "" ;
            this.typeName ="";
            this.itemTypeId = "";
            this.popLoad=true;
            this.service.getMake(this.id).subscribe((res:any)=>{
              if(res){
                this.makeObj = res;
                this.popLoad=false;
                this.loader=false;
              }else{
                this.loader=false;
              }
            },err=>{
              this.loader=false;
              this.handler.err(err)
            })
          }
          detailPopupClose(){
            this.typePopupCheck=false;
            this.typeName=sessionStorage.getItem('itemItpeName')
          
          }
          openBottomSheet1(): void {
         const dialogRef = this.bottomSheet.open(BottomSheet,{
              data: this.makeObj,
            });
            dialogRef.afterDismissed().subscribe((res:any) => {
            this.makeName = res.name;
            this.makeId = res.id; 
            this.modelName = "" ;
            this.typeName ="";
            this.itemTypeId = "";
            this.modelObj="";
                if(this.makeName){
                  this.getCustModel();
                }   
                sessionStorage.setItem('make', this.makeName);
                sessionStorage.setItem('makeId', this.makeId);
            });
          }
          openBottomSheet2(): void {
         const dialogRef = this.bottomSheet.open(BottomSheet,{
             data: this.modelObj,
           });
           dialogRef.afterDismissed().subscribe((res:any) => {
             if(res){
               this.modelName = res.name;
               this.modelId = res.id; 
               this.typeName ="";
               this.itemTypeId = "";
               if(this.modelName){
                this.getCustitemType();
              }             
             }
             sessionStorage.setItem('model', this.modelName);
             sessionStorage.setItem('modelId', this.modelId);
           });
          
          }
          getCustModel(){
            this.popLoad=true;
            this.service.getModel(this.id,this.makeId).subscribe((res:any)=>{
              if(res){
                this.modelObj = res;   
                this.popLoad=false;
              }  else{
                this.popLoad=false;
                this.handler.res('Model not available for this make!!! Please choose equivalent make')
              }
            },
            err=>{
              this.popLoad=false;
              this.handler.err(err);
          
            })
          }
          
          
          getCustitemType(){
            this.popLoad=true;
          this.service.getCustItemType(this.id,this.makeId,this.modelId).subscribe((res:any)=>{
                if(res){
                this.typeObj = res;
                this.typeObj.map(res1=>{
                  this.itemTypeId = res1.itemTypes[0].id;
                  sessionStorage.setItem('itemTypeId',this.itemTypeId)
                  this.typeName=res1.itemTypes[0].name;
                  this.typeCode =res1.itemTypes[0].code;
                  if(res1.itemTypes[0].docId){
                    this.getDoc(res1.itemTypes[0].docId);
                    this.docId=res1.itemTypes[0].docId;  
                  }
                 })
                  this.popLoad =false;
                }else{
                  this.popLoad=false;
                  this.handler.res('Item Type not available for this make and model!!! Please choose equivalent make')
                } 
              },
              err=>{
                this.popLoad=false;
                this.handler.err(err);          
              })
            }
            checkService(){
              if(sessionStorage.getItem('newOrderId')){
                this.UpdateService();
              }else{
                this.typePopupCheck=false;
              }
          }
          UpdateService(){
            this.loader = true; 
            if(this.cateCode=="CAR"){  
              Object.assign(this.orderItems,{"itemTypeId": sessionStorage.getItem('itemTypeId')})
            }
         this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{   
           sessionStorage.setItem('region',this.region);
           this.handler.res('Cost Updated Successfully , based on region and item type!!')
           this.typePopupCheck=false;
           this.loader = false;
         },err => {
           this.loader = false;
           this.handler.err(err)
         })
        }

        newPlaceOrder(){
          this.updatePop=true;
          this.getOrder(this.orderId);
        }
        startDate(){
          this.fDate=this.returnDate(this.startdate);
          this.slotDate=this.returnDate1(this.startdate);
          this.time = "Time"
        }
        returnDate(data) {
          let date = data.getDate();
          date = date < 10 ? '0' + date : date;
         let month = data.getMonth() + 1;
         month = month < 10 ? '0' + month : month;
         let year = data.getFullYear();  
         return year + '-' + month + '-' + date;
       }
       returnDate1(data) {
        let date = data.getDate();
        date = date < 10 ? '0' + date : date;
       let month = data.getMonth() + 1;
       month = month < 10 ? '0' + month : month;
       let year = data.getFullYear();  
       return date + '-' + month + '-' + year;
     }
     checkPreview(){
      this.openSlot = true;
      this.slotClicked =false;
      var post ={
        "targetCenterId": this.orgId,
        "targetSource": this.orgId,
        "schElements": [
            1
        ],
        "requestDate": this.fDate,
        "status": [
            "SlotsAvailable"
        ],
        "independentEntities": true,
        "slotDuration": 15
    }
      this.service.getTimeSlots(this.slotDate,post).subscribe((res: any) => {
        if (res){
          this.availableSlots = res;
          this.availSlot = true;
          this.slotClicked = true;
        }else{
           this.handler.res("No Available Slots");
           this.availSlot = false;
           this.slotClicked = true;
        }
        
      },err=>{
        this.availSlot = false;
        this.slotClicked = true;
      })
    }
    blockDate(){
      // Block From Date
      var someDate = new Date();
      var numberOfFromDaysToAdd = 1;
      someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd); 
      var dd = someDate.getDate();
      var mm = someDate.getMonth() + 1;
      var month = mm-1;
      var y = someDate.getFullYear();
      this.fdateCheck = new Date(y, month, dd)
    }
    setTime(data){
      this.time = data.startTime;
      this.endTime = data.endTime;
      this.slot = data;
      this.slotClicked = false;
      this.openSlot = false;
      this.changeDate = true;
    }

    UpdateVendorService(){
       if (this.changeDate){
        Object.assign(this.orderItems,{"type": 1,
        "capacityDefId":  '1',
        "apptTime": this.time,
        "apptDate": this.fDate,
        "apptStartTime":this.time,   
        "apptEndTime":  this.endTime,
        "requestDates": [
          {
              "apptDate": this.fDate,
              "apptTime":  this.time,  
              "apptEndTime":  this.endTime ,         
              "status": 1
          }]})
        Object.assign(this.orderItems,{cnvcChargeApplied:true})  
        if(this.notes){
          Object.assign(this.purrchaseItems,{"notes": this.notes
        })   
        }    
    this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{    
      this.PlaceOrder();
    },err => {
      this.loader = false;
      this.handler.err(err)
    })
       }else{
        this.loader = false;
        this.handler.err('Please Enter Required Fields')
       }
   
   }
ionViewWillLeave(){
  this.initialTypePopup=false;
  this.typePopupCheck=false;
}

  applyDiscount(){
    this.loader=true
    if(sessionStorage.getItem('newOrderId')){
      this.preOrderId=sessionStorage.getItem('newOrderId')
    }
    if(this.discountAmt){
      this.discountAmt = this.discountAmt.toUpperCase();
    }
    this.service.applyDiscountOrder(this.preOrderId,this.discountAmt).subscribe(res => {
      this.newPlaceOrder()
      this.creditCheck=false;
      this.discountAmt = undefined;
      this.loader=false;
    },
      err => {
        this.loader=false;
        this.handler.err(err)
      })

  }
  applyCredit(){
    this.loader=true
    if(sessionStorage.getItem('newOrderId')){
      this.preOrderId=sessionStorage.getItem('newOrderId')
    }
    Object.assign(this.purrchaseItems,{"creditPoints": this.criditValue
  }) 
   this.service.applyCredits(this.preOrderId ,this.purrchaseItems).subscribe((res:any)=>{
    this.newPlaceOrder();
    this.couponCheck=false;
  },
    err => {
      this.loader = false;
      this.handler.err(err)
   })


  }

  removeCredit(){
    this.loader = true;
    this.service.removeCredits(this.preOrderId).subscribe(res => {
      this.newPlaceOrder();
      this.couponCheck = true;
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }

  Stay(){
    this.typeConfirmPop = false;
  }
  remove(){
    this.loader=true
    this.service.applyDiscountOrderRemove(this.preOrderId,this.purrchaseItems.couponCode).subscribe(res => {
      this.newPlaceOrder();
      this.creditCheck = true;
      this.loader=false;
    },
      err => {
        this.loader=false;
        this.handler.err(err)
      })
  }
  clear(){
    this.orderId=''
    sessionStorage.removeItem('newOrderId')
    this.typeConfirmPop=false;
  }  
  closePop(){
    this.detailsPop=false;
  } 
  details(data){
    this.detailsPop=true;
    this.detailText=data.description;
  }      
}